import custom from './custom';
import NewContentAvailable from '../components/ExternalNotif';

export const externalNotif = () => custom.warningSticky(NewContentAvailable);
